// src/common/components/cartModal/components/checkout-stage/components/cdekOfferCard/CdekOfferCard.tsx

import React from "react";
import Button from "../../../../button/Button";
import styles from "./CdekOfferCard.module.scss";
import { useTheme } from "../../../../../hooks/useTheme";

interface CdekOfferCardProps {
  type: "courier" | "pickup";
  pointType?: "PVZ" | "POSTAMAT";
  name: string;
  price: number;
  periodMin: number;
  periodMax: number;
  address?: string;
  workTime?: string;
  phone?: string;
  latitude?: number;
  longitude?: number;
  isSelected: boolean;
  onSelect: () => void;
}

export default function CdekOfferCard({
  type,
  pointType,
  name,
  price,
  periodMin,
  periodMax,
  address,
  workTime,
  phone,
  latitude,
  longitude,
  isSelected,
  onSelect,
}: CdekOfferCardProps) {
  const { theme } = useTheme();

  const openInMaps = () => {
    if (address) {
      const query = encodeURIComponent(`СДЭК ${address}`);
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${query}`,
        "_blank",
      );
    } else if (latitude && longitude) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
        "_blank",
      );
    }
  };

  const getTypeLabel = () => {
    if (type === "courier") return "🚚 Курьер";
    if (pointType === "POSTAMAT") return "📦 Постамат";
    return "📦 ПВЗ";
  };

  return (
    <div
      className={`${styles.card} ${isSelected ? styles.selected : ""}`}
      onClick={onSelect}
      style={{
        borderColor: isSelected ? theme.primary : theme.border,
        backgroundColor: isSelected ? theme.primary + "15" : theme.card,
      }}
    >
      <div className={styles.header}>
        <span className={styles.type} style={{ color: theme.primary }}>
          {getTypeLabel()}
        </span>
        <span className={styles.price} style={{ color: theme.text }}>
          {price} ₽
        </span>
      </div>

      <div className={styles.name} style={{ color: theme.text }}>
        {name}
      </div>

      <div className={styles.period} style={{ color: theme.textSecondary }}>
        {periodMin}-{periodMax} дн.
      </div>

      {type === "pickup" && address && (
        <>
          <div className={styles.address} style={{ color: theme.text }}>
            {address}
          </div>
          {workTime && (
            <div
              className={styles.workTime}
              style={{ color: theme.textSecondary }}
            >
              🕐 {workTime}
            </div>
          )}
          {phone && (
            <div
              className={styles.phone}
              style={{ color: theme.textSecondary }}
            >
              📞 {phone}
            </div>
          )}
          <Button
            title="Открыть в картах"
            variant="secondary"
            size="small"
            onClick={openInMaps}
          />
        </>
      )}
    </div>
  );
}
